<div class="iss">
  <h2>Resolve outstanding issues</h2>
  <div class="iss__banner" *ngIf="banner" [class.iss__banner--error]="banner.type === 'error'">
    {{ banner.text }}
    <a *ngIf="banner.text.includes('Reprint')" [routerLink]="['/batchpick', batchId, 'verify']">Go to the verify screen</a>
  </div>
  <p class="iss__hint" *ngIf="!loading && issues.length === 0">All resolved.</p>

  <ul class="iss__list">
    <li *ngFor="let i of issues">
      <div class="iss__row">
        <div *ngIf="i.kind === 'WrongBasket'">
          <div class="iss__title">
            Wrong basket — Med <code>{{ i.medicationId }}</code>
          </div>
          <div class="iss__sub">
            Found in basket #{{ i.scannedInBasket }} · Expected in basket #{{ i.expectedBasket }}
          </div>
        </div>
        <div *ngIf="i.kind === 'OrphanStock'">
          <div class="iss__title">
            Orphan stock — {{ i.scannedProductId }}
          </div>
          <div class="iss__sub">No matching prescription in this batch.</div>
        </div>
        <button class="btn btn-primary" (click)="resolve(i)">
          {{ i.kind === 'WrongBasket' ? 'Mark moved' : 'Return to stock' }}
        </button>
      </div>
    </li>
  </ul>

  <button class="btn btn-primary"
          [disabled]="(issues.length > 0 && !finished) || finishing"
          (click)="finish()">
    {{ finished ? 'Go to the verify screen' : 'Finish Verifying' }}
  </button>
</div>
